module.exports = __webpack_public_path__ + "static/media/settings.df3948a1.png";